import { render, staticRenderFns } from "./IncommingcallDisplaySettingModal.vue?vue&type=template&id=2955686c&"
import script from "./IncommingcallDisplaySettingModal.vue?vue&type=script&lang=js&"
export * from "./IncommingcallDisplaySettingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports